import type { FactoryImage } from '@indutrust/factory-model';
import { createCrudEvents } from '@indutrust/shared-util';

/**
 * Standard CRUD events for a factory's image gallery collection.
 *
 * Backed by {@link import('../factory-image-api-client.service').FactoryImageApiClient}
 * at `/factories/{factoryId}/images`. Dispatchers must always pass
 * `urlSegments: { factoryId }` so the request resolves the parent factory.
 *
 * Source namespace: `factory.image` — keeps the Redux DevTools trace
 * grouped with the other factory sub-resources.
 *
 * @example
 * const dispatch = injectDispatch(factoryImageCrudEvents);
 * dispatch.loadAllRequested({ urlSegments: { factoryId: 7 } });
 */
export const factoryImageCrudEvents =
  createCrudEvents<FactoryImage>('factory.image');
